import { gql, TypedDocumentNode } from '@apollo/client';
import { AnnuityRates } from 'types';

export const GetRates: TypedDocumentNode<{ getRates: AnnuityRates }> = gql`
    query GetRates {
        getRates {
            sixtySix10k
            sixtySix100k
            sixtySeven10k
            sixtySeven100k
        }
    }
`;
